let value = 0;
let mode: 'sse' | 'poll' | 'off' = 'off';

const listeners = new Set<() => void>();
const modeListeners = new Set<() => void>();

export function getUnreadTotal() {
  return value;
}
export function setUnreadTotal(next: number) {
  const normalized = Math.max(0, next | 0);
  if (normalized === value) return;
  value = normalized;
  listeners.forEach((l) => l());
}
export function subscribeUnread(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function getUnreadMode() {
  return mode;
}
export function setUnreadMode(next: typeof mode) {
  if (next === mode) return;
  mode = next;
  modeListeners.forEach((l) => l());
}
export function subscribeUnreadMode(cb: () => void) {
  modeListeners.add(cb);
  return () => modeListeners.delete(cb);
}
